<div id="search-speciality" [dir]="dir">
  <div class="search-section">
    <!-- Info and Date Picker -->
    <div class="slot-options">
      <div class="info-msg-text-wrapper">
        <img src="assets/icons/slot/info.svg" alt="info" />
        <span class="info-text-msg" *ngIf="!isReschedule">{{ 'slot_notes' | translate }}</span>
        <span class="info-text-msg" *ngIf="isReschedule">{{ 'previous_appointment' | translate }}{{" "}} {{rescheduleParams['appointmentDateTime'] | apptTime: 'FORMAT':('D MMM YYYY, hh:mm a'):('YYYY-MM-DD HH:mm') : 'FACILITY' : facilityId}} </span>
      </div>

      <div class="date-selection">
        <div class="date-picker cursor-pointer" (click)="openPicker()">
          <span class="date">
            {{ slotList.dates.length > 0 ? (slotList.dates[0] | moment : 'DD MMM' : 'YYYY-MM-DD') : '' }} -
            <span *ngIf="slotList.dates.length > 0">{{ slotList.dates[endIndex - 1] | moment : 'DD MMM' : 'YYYY-MM-DD' }}
            </span>
          </span>
          <img src="assets/icons/calendar-simple.svg" alt="calendar" />
        </div>
        <vaadin-date-picker [min]="curDate" [value]="curDate" id="date-range" class="vaadin-hidden-date"
          (change)="vaadinChange($event)" #vaadinDp></vaadin-date-picker>
      </div>
    </div>

    <div class="slot-wrapper web-view">
      <div class="slot-arrow-column prev" [class.disabled]="startIndex <= 0" (click)="changeStart(-1)">
        <div class="slot-arrow">
          <img src="assets/icons/Home/up arrow.svg" alt="Previous" />
        </div>
      </div>
      <div class="slot-content">
        <div class="slot-header-row">
          <div class="slot-date-header" *ngFor="let date of slotList.dates | slice: startIndex : endIndex">
            {{ date | moment : 'ddd, DD MMM YYYY' : 'YYYY-MM-DD' }}
          </div>
        </div>

        <div class="slot-body-wrapper">
          <div class="slot-column" *ngFor="let date of slotList.dates | slice: startIndex : endIndex">
            <div class="slots-container">
              <ng-container *ngIf="slotList['slots']?.[date] as slots; else noSlot">
                <div class="slot-btn"
                  *ngFor="let slot of [].concat(slots.mrng || [], slots.noon || [], slots.eve || [])"
                  [ngClass]="{ selectedSlot:  date == selectedDate && slot['time'] == selectedSlot['time']}"
                  (click)="completeSelection(date, slot)">
                  {{ slot['time'] | moment : 'hh:mm A' : 'HH:mm' }}
                  <img [src]="slot._icon" class="slot-icon" />
                </div>
              </ng-container>
              <ng-template #noSlot>
                <div class="no-slot">{{ 'No_slots_available' | translate }}</div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="slot-arrow-column next" [class.disabled]="endIndex >= slotList.dates.length" (click)="changeStart(1)">
        <div class="slot-arrow">
          <img src="assets/icons/Home/up arrow.svg" alt="Next" />
        </div>
      </div>
    </div>


    <div class="slot-table mobile-view">
  <div class="date-tabs">
    <div
      *ngFor="let date of slotList.dates"
      class="date-tab"
      [ngClass]="{ active: date === selectedDate }"
      (click)="selectedDate = date"
    >
      <span class="day">{{ date | moment : 'ddd' : 'YYYY-MM-DD' }}</span>
      <span class="num">{{ date | moment : 'DD' : 'YYYY-MM-DD' }}</span>
    </div>
  </div>

  <div class="slots-container">
    <ng-container *ngIf="slotList['slots']?.[selectedDate] as slots; else noSlotMobile">
      <div
        class="slot-btn"
        *ngFor="let slot of [].concat(slots.mrng || [], slots.noon || [], slots.eve || [])"
        [ngClass]="{ selectedSlot: selectedDate && slot['time'] === selectedSlot['time'] }"
        (click)="completeSelection(selectedDate, slot)"
      >
        {{ slot['time'] | moment : 'hh:mm A' : 'HH:mm' }}
        <img [src]="slot._icon" class="slot-icon" />
      </div>
    </ng-container>

    <ng-template #noSlotMobile>
      <div class="no-slot">No slots available</div>
    </ng-template>
  </div>
</div>
  </div>
</div>


<app-consultation-type-modal *ngIf="openConsultationTypeSelection"   (close)="handleClose()" (confirm)="handleConfirm($event)"></app-consultation-type-modal>